export let assign = Object.assign;
export function fillNulls(count) {
  let arr = new Array(count);

  for (let i = 0; i < count; i++) {
    arr[i] = null;
  }

  return arr;
}
export function values(obj) {
  const vals = [];

  for (const key in obj) {
    vals.push(obj[key]);
  }

  return vals;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3BhY2thZ2VzL0BnbGltbWVyL3V0aWwvbGliL29iamVjdC11dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLElBQUksTUFBTSxHQUFHLE1BQU0sQ0FBQyxNQUFwQjtBQUVQLE9BQU0sU0FBVSxTQUFWLENBQXVCLEtBQXZCLEVBQW9DO0FBQ3hDLE1BQUksR0FBRyxHQUFHLElBQUksS0FBSixDQUFVLEtBQVYsQ0FBVjs7QUFFQSxPQUFLLElBQUksQ0FBQyxHQUFHLENBQWIsRUFBZ0IsQ0FBQyxHQUFHLEtBQXBCLEVBQTJCLENBQUMsRUFBNUIsRUFBZ0M7QUFDOUIsSUFBQSxHQUFHLENBQUMsQ0FBRCxDQUFILEdBQVMsSUFBVDtBQUNEOztBQUVELFNBQU8sR0FBUDtBQUNEO0FBRUQsT0FBTSxTQUFVLE1BQVYsQ0FBb0IsR0FBcEIsRUFBMkM7QUFDL0MsUUFBTSxJQUFJLEdBQUcsRUFBYjs7QUFDQSxPQUFLLE1BQU0sR0FBWCxJQUFrQixHQUFsQixFQUF1QjtBQUNyQixJQUFBLElBQUksQ0FBQyxJQUFMLENBQVUsR0FBRyxDQUFDLEdBQUQsQ0FBYjtBQUNEOztBQUNELFNBQU8sSUFBUDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGxldCBhc3NpZ24gPSBPYmplY3QuYXNzaWduO1xuXG5leHBvcnQgZnVuY3Rpb24gZmlsbE51bGxzPFQ+KGNvdW50OiBudW1iZXIpOiBUW10ge1xuICBsZXQgYXJyID0gbmV3IEFycmF5KGNvdW50KTtcblxuICBmb3IgKGxldCBpID0gMDsgaSA8IGNvdW50OyBpKyspIHtcbiAgICBhcnJbaV0gPSBudWxsO1xuICB9XG5cbiAgcmV0dXJuIGFycjtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHZhbHVlczxUPihvYmo6IHsgW3M6IHN0cmluZ106IFQgfSk6IFRbXSB7XG4gIGNvbnN0IHZhbHMgPSBbXTtcbiAgZm9yIChjb25zdCBrZXkgaW4gb2JqKSB7XG4gICAgdmFscy5wdXNoKG9ialtrZXldKTtcbiAgfVxuICByZXR1cm4gdmFscztcbn1cbiJdLCJzb3VyY2VSb290IjoiIn0=